module.exports = __webpack_public_path__ + "static/media/backward-time.c8ce85cb.svg";